// components/StockTables/OpeningStockTable.jsx
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import * as actions from '../../../redux/actions';
import _ from 'lodash';

const OpeningStockTable = ({ data }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState();
  const [date, setDate] = useState();

  const stock = data && data.length > 0 ? data[0].stock : [];

  // Group ตาม place.name
  const grouped = _.groupBy(stock, (item) => item.place || 'ไม่ระบุคลัง');

  // ฟังก์ชัน sort ให้ 96.5% ขึ้นก่อน
  const sortMaterialType = (arr) =>
    _.orderBy(
      arr,
      [
        (item) => (item.material_type === '96.5%' ? 0 : 1),
        (item) => item.material_type,
      ],
      ['asc', 'asc'],
    );

  // const getFormattedItemValue = (item) => {
  //   if (!item?.weight || !item?.cost) {
  //     return '-';
  //   }

  //   let calculatedValue;
  //   if (item.place === 'คลังอื่นๆ') {
  //     calculatedValue = item.cost / item.weight;
  //   } else if (item.isbar || ['ทองคำแท่ง', 'ทองแท่ง'].includes(item.name)) {
  //     calculatedValue = (item.cost / item.weight) * 15.244;
  //   } else {
  //     calculatedValue = (item.cost / item.weight) * 15.16;
  //   }

  //   return calculatedValue.toLocaleString(undefined, {
  //     minimumFractionDigits: 2,
  //     maximumFractionDigits: 2,
  //   });
  // };

  return (
    <div className="bg-white rounded-lg shadow-sm overflow-hidden">
      <div className="overflow-x-auto">
        {Object.entries(grouped)
          .sort(([a], [b]) => (a === 'คลังรูปพรรณใหม่' ? -1 : 1))
          ?.map(([placeName, items]) => (
            <div key={placeName} className="mb-8">
              <div className="font-bold text-md mb-2  pl-4">{placeName}</div>
              <table className="w-full">
                <thead className="bg-yellow-400">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-bold text-gray-800 border-r border-gray-300">
                      รายการสินค้า
                    </th>
                    <th className="px-4 py-3 text-center text-sm font-bold text-gray-800 border-r border-gray-300">
                      ประเภท
                    </th>
                    {items?.some((item) => item?.place !== 'คลังอื่นๆ') ? (
                      <th className="px-4 py-3 text-center text-sm font-bold text-gray-800 border-r border-gray-300">
                        น้ำหนัก
                      </th>
                    ) : (
                      <th className="px-4 py-3 text-center text-sm font-bold text-gray-800 border-r border-gray-300">
                        จำนวนคงเหลือ
                      </th>
                    )}
                    <th className="px-4 py-3 text-center text-sm font-bold text-gray-800 border-r border-gray-300">
                      มูลค่ารวม
                    </th>
                    <th className="px-4 py-3 text-center text-sm font-bold text-gray-800">
                      {placeName === 'คลังอื่นๆ'
                        ? 'มูลค่าเฉลี่ย'
                        : 'มูลค่าเฉลี่ยต่อบาท'}
                      <br />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {sortMaterialType(items).map((item, idx) => (
                    <tr key={item.material_id || idx}>
                      <td className="px-4 py-2 border-r">{item.name}</td>
                      <td className="px-4 py-2 border-r text-center">
                        {item.material_type || '-'}
                      </td>
                      <td className="px-4 py-2 border-r text-center">
                        {item?.isbar ||
                        ['ทองคำแท่ง', 'ทองแท่ง'].includes(item?.name)
                          ? item.weight?.toLocaleString(undefined, {
                              minimumFractionDigits: 3,
                              maximumFractionDigits: 3,
                            }) || '-'
                          : item.weight?.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) || '-'}
                      </td>
                      <td className="px-4 py-2 border-r text-center">
                        {item.cost?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) || '-'}
                      </td>
                      <td className="px-4 py-2 text-center">
                        {item?.costperbath != null
                          ? item.costperbath.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : item?.avarage_cost != null
                          ? item.avarage_cost.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : '-'}
                      </td>
                    </tr>
                  ))}
                  {items.length === 0 && (
                    <tr>
                      <td
                        colSpan="5"
                        className="text-center py-6 text-gray-500"
                      >
                        ไม่มีข้อมูล
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          ))}
      </div>
    </div>
  );
};

export default OpeningStockTable;
